module.exports = __webpack_public_path__ + "img/901267615.cac45f79.png";